import { useMediaQuery } from 'react-responsive';
import { ITableContainerProps } from '../../../types/Interfaces';
import { IOrder } from '../../orders/types/interfaces';

const OrdersTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IOrder[]>) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map(
          (header, index) =>
            header && (
              <span className={`head ${header.customClass}`} key={index}>
                {header.label}
              </span>
            )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div className="item vehicles" key={index}>
                <div className="column">{item?.id || '-'}</div>
                <div className="column">{item?.date || '-'}</div>
                <div className="column">{Number(item?.order_value)?.toLocaleString('en-US') || '-'}</div>
                <div className="column">
                  <div className="capitalize">{item?.status || '-'}</div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default OrdersTableContainer;
